// import { styled } from "@mui/material/styles";
// import { default as MuiTab } from "@mui/material/Tab";
// import React from "react";

// interface StyledTabProps {
//   label: React.ReactNode | string;
//   value?: any; // Make the value prop optional
//   icon?:
//     | string
//     | React.ReactElement<any, string | React.JSXElementConstructor<any>>
//     | undefined;
//   iconPosition?: "bottom" | "top" | "start" | "end" | undefined;
// }

// export const Tab = styled((props: StyledTabProps) => (
//   <MuiTab disableRipple {...props} />
// ))(({ theme }) => ({
//   // textTransform: "capitalize",
//   // mr: "12px",
//   // ...theme.typography["body-large"],
//   // "&:hover": {
//   //   color: theme.palette.purple.main,
//   // },
//   // "&.Mui-selected": {
//   //   color: theme.palette.purple.main,
//   // },
//   // color: theme.palette.lightBg.low,
// }));

//new updated code

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { default as MuiTab, TabProps as MuiTabProps } from "@mui/material/Tab";
import { Vertical3DotsIcon } from "components/icons";
import { DropdownMenu } from "components/menu";
import React from "react";

interface StyledTabProps extends Omit<MuiTabProps, "children"> {
  label: React.ReactNode | string;
  options?: string[];
  onMenuItemClicked?: (value: string) => void;
  /**
   * A React component or icon rendered in front of the label.
   * Pass a node for a static adornment, or a render function that
   * receives the tab's `selected` state to style active vs. inactive tabs.
   */
  startAdornment?: React.ReactNode | ((selected: boolean) => React.ReactNode);
}

// const StyledTab = styled(MuiTab, {
//   shouldForwardProp: (prop) => prop !== "hasOptions",
// })<{ hasOptions?: boolean }>(({ theme, hasOptions }) => ({
//   position: "relative",
//   paddingRight: hasOptions ? "48px" : undefined,
// }));

// Styled Tab with button-like appearance
const StyledTab = styled(MuiTab, {
  shouldForwardProp: (prop) =>
    !["hasOptions", "isButtonStyle"].includes(prop as string),
})<{ hasOptions?: boolean; isButtonStyle?: boolean }>(
  ({ theme, hasOptions, isButtonStyle }) => ({
    position: "relative",
    paddingRight: hasOptions ? "48px" : undefined,
    // Button-like styling
    ...(isButtonStyle && {
      borderRadius: "4px",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      "&&": {
        color: "black",
      },
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      // Add more specific padding to make it look like a button
      padding: "6px 16px !important",
      minHeight: "36px",
      marginTop: "10px",
      // marginRight: "-20px",
      fontWeight: 500,
      textTransform: "none",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      transition: "background-color 0.3s, box-shadow 0.3s",
      "&.Mui-selected": {
        backgroundColor: theme.palette.neutral["B-005"],
        color: theme.palette.primary.contrastText,
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        border: `1px solid ${theme.palette.primary.main}`,
        padding: "6px 16px",
      },
    }),
    // Make sure text and icon align properly
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
  }),
);

const MenuButton = styled(Box)(({ theme }) => ({
  position: "absolute",
  right: "8px",
  top: "50%",
  transform: "translateY(-50%)",
}));

export const Tab: React.FC<StyledTabProps & { buttonStyle?: boolean }> = (
  props,
) => {
  const {
    options,
    onMenuItemClicked,
    buttonStyle = false,
    startAdornment,
    label,
    sx,
    ...tabProps
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const { options, onMenuItemClicked, buttonStyle = true, ...tabProps } = props;
  const open = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   event.stopPropagation();
  //   setAnchorEl(event.currentTarget);
  // };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hasOptions = options && options.length > 0;

  // MUI injects `selected` into each Tab rendered inside <Tabs>, but it isn't
  // part of the public TabProps type, so read it via a narrow cast.
  const selected = Boolean((tabProps as { selected?: boolean }).selected);
  const resolvedAdornment =
    typeof startAdornment === "function"
      ? startAdornment(selected)
      : startAdornment;

  const composedLabel = startAdornment ? (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", gap: "8px" }}
    >
      {resolvedAdornment}
      <Box component="span">{label}</Box>
    </Box>
  ) : (
    label
  );

  const iconWithMenu = hasOptions ? (
    <>
      {props.icon}
      <MenuButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
      >
        <DropdownMenu
          options={options.map((item) => ({ value: item, name: item }))}
          onOptionClick={({ value, name }) => {
            onMenuItemClicked?.(value || "");
            handleClose();
          }}
        >
          <Vertical3DotsIcon />
        </DropdownMenu>
      </MenuButton>
    </>
  ) : (
    props.icon
  );

  return (
    <>
      <StyledTab
        disableRipple
        {...tabProps}
        label={composedLabel}
        hasOptions={hasOptions}
        isButtonStyle={buttonStyle}
        icon={iconWithMenu}
        iconPosition={hasOptions ? "end" : props.iconPosition}
        sx={sx}
      />
    </>
  );
};

// import React from "react";
// import { styled } from "@mui/material/styles";
// import { default as MuiTab, TabProps as MuiTabProps } from "@mui/material/Tab";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { ThreeDotOptionsGeneral } from "components/three-dot-option-general";

// interface StyledTabProps extends Omit<MuiTabProps, "children"> {
//   label: React.ReactNode | string;
//   options?: string[];
// }

// const StyledTab = styled(MuiTab, {
//   shouldForwardProp: (prop) => prop !== "hasOptions",
// })<{ hasOptions?: boolean }>(({ theme, hasOptions }) => ({
//   position: "relative",
//   paddingRight: hasOptions ? "48px" : undefined,
// }));

// const MenuButton = styled(IconButton)(({ theme }) => ({
//   position: "absolute",
//   right: 0,
//   top: "50%",
//   transform: "translateY(-50%)",
// }));

// const StyledThreeDotWrapper = styled("div")(({ theme }) => ({
//   position: "absolute",
//   right: 8,
//   // top: "50%",
//   // transform: "translateY(-50%)",
// }));

// export const Tab: React.FC<StyledTabProps> = (props) => {
//   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
//   const open = Boolean(anchorEl);

//   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
//     event.stopPropagation();
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const { options, ...tabProps } = props;
//   const hasOptions = options && options.length > 0;

//   const iconWithMenu = hasOptions ? (
//     // <>
//     //   {props.icon}
//     //   <MenuButton
//     //     size="small"
//     //     aria-label="more"
//     //     id="long-button"
//     //     aria-controls={open ? "long-menu" : undefined}
//     //     aria-expanded={open ? "true" : undefined}
//     //     aria-haspopup="true"
//     //     onClick={handleClick}
//     //   >
//     //     <MoreVertIcon fontSize="small" />
//     //   </MenuButton>
//     // </>
//     <StyledThreeDotWrapper>
//       <ThreeDotOptionsGeneral
//         options={[
//           { name: "Download", value: "download" },
//           { name: "Delete", value: "delete" },
//         ]}
//         onOptionClick={(option: string) => {
//           console.log("🚀 ~ option:", option);
//           // optionFunction({ option, data });
//         }}
//       />
//     </StyledThreeDotWrapper>
//   ) : (
//     props.icon
//   );

//   return (
//     <>
//       <StyledTab
//         disableRipple
//         {...tabProps}
//         hasOptions={hasOptions}
//         icon={iconWithMenu}
//         iconPosition={hasOptions ? "end" : props.iconPosition}
//       />
//       {hasOptions && (
//         <Menu
//           id="long-menu"
//           MenuListProps={{
//             "aria-labelledby": "long-button",
//           }}
//           anchorEl={anchorEl}
//           open={open}
//           onClose={handleClose}
//         >
//           {options.map((option) => (
//             <MenuItem key={option} onClick={handleClose}>
//               {option}
//             </MenuItem>
//           ))}
//         </Menu>
//       )}
//     </>
//   );
// };
